import React from 'react';

import {observer} from "mobx-react";
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import styles from "../styles/entity-scores-widget.module.scss";
import classNames from "classnames";
import {ENTITY_SCORES} from "../entity-scores-widget.consts";
import {NavigationTabsModuleAsync} from "../../../modules/navigation-tabs-module/components/navigation-tabs-module.async";
import classnames from "classnames";
import {EntityScoresWidgetHeaderOddsToggle} from "./entity-scores-widget.header.odds-toggle";
import {EntityScoresWidgetDropdown} from "./entity-scores-widget.dropdown";

export class EntityScoresWidgetHeaderProps extends BaseProps {}

export const EntityScoresWidgetHeader = observer(({controller}: EntityScoresWidgetHeaderProps) => {
  const {state, device} = controller;
  const {entity, tabsContext} = state;
  const {isSmallView} = device;

  const onTabClick = (tab) => {
    controller.action(ENTITY_SCORES.ACTION_HANDLERS.tabClick, {tab: tab})

    return true;
  }

  const tabsProps = {
    className: classnames(styles.tabs),
    tabClassName: classnames(styles.tab),
    onTabChange: (index) => onTabClick && onTabClick(index),
    entity,
    supportArrows: true,
    context: tabsContext,
    // isLoading: controller.state.fetchingState === FETCHING_STATES.fetching || controller.state.componentState === COMPONENT_STATES.loading
  }

  return (
    <div className={classNames(styles.header)}>
      {
        !isSmallView ? <EntityScoresWidgetHeaderOddsToggle controller={controller}/> : null
      }
      <div className={classNames(styles.tabs_container)}>
        <NavigationTabsModuleAsync {...tabsProps}/>
      </div>
      {
        !isSmallView ? <EntityScoresWidgetDropdown controller={controller}/> : null
      }
    </div>
  )
});